<template>
    <div class="modal-card" style="width:440px">
        
        <header class="modal-card-head">
            <p class="modal-card-title">Firmadetaljer</p>
        </header>
        <form @submit="checkForm" @submit.prevent="commitChanges">
            <section class="modal-card-body">

                <div class="field">
                    <b-checkbox v-model="allBaxComputed">
                        Alle bax
                    </b-checkbox>
                </div>

                <b-field label="Spesifikke bax">
                    <b-taginput :disabled="allBax" v-model="emailItem.baxNumbers"></b-taginput>
                </b-field>

                <b-field label="Rapporttype">
                    <b-select placeholder="Velg rapporttype" v-model="emailItem.reportType" v-on:input="requiresExportFormat" required>
                        <option
                            v-for="option in reportTypes"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Type eksport" v-if="displayExportFormat">
                    <b-select placeholder="Velg rapporttype" v-model="emailItem.exportFormat" required>
                        <option
                            v-for="option in exportFormats"
                            :value="option.id"
                            :key="option.id">
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Send epost til (angi flere med komma)">
                    <b-taginput v-model="emailItem.emailReceivers"></b-taginput>
                </b-field>

                <div class="field" v-if="errorMsg">
                    <span class="is-danger">{{ errorMsg }}</span>
                </div>

            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Avbryt</button>
                <button type="submit" class="button is-primary">Ok</button>
            </footer>
        </form>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['emailItem'],
    data () {
        return {
            errorMsg: undefined,
            allBax: this.emailItem.allBax,
            errors: [],
            displayExportFormat: true
        }
    },
    computed: {
        ...mapGetters('reporttypes', ['reportTypes']),
        ...mapGetters('emailreports', ['exportFormats']),
        allBaxComputed: {
            get () { return this.allBax },
            set (value) { 
                this.emailItem.allBax = value
                this.allBax = value
                
                if (value === true)
                    this.emailItem.baxNumbers = []
            }
        }
    },
    methods: {
        ...mapActions('emailreports', ['saveEmailSettings']),
        checkForm: function () {
            this.errors.push("Name required.")

            return true

            // e.preventDefault()
        },
        requiresExportFormat () {
            if (this.emailItem.reportType === 6 || this.emailItem.reportType === 7) {
                this.displayExportFormat = false
                this.emailItem.exportFormat = undefined
            } else {
                this.displayExportFormat = true

            }
        },
        async commitChanges () {
            try {
                await this.saveEmailSettings(this.emailItem)
                this.$parent.close()
            } catch (error) {
                this.errorMsg = error.message
            }
        }
    }
}
</script>
